export enum MoverSteps {
  AddHouse,
  MakeAppointment,
  Finalize
}
